module.exports = __webpack_public_path__ + "img/L_9S.4ab14587.png";